<template>
  <div>
    <header-bar>
      著作権スプリット
    </header-bar>
    <div class="page-block">
      <div class="page-block__inner">
        <div class="cancelled-content">
          <div class="title">
            著作権スプリットへの招待をキャンセルしました。
          </div>
          <div class="subtitle">
            当リリースの著作権スプリットが開始されることはありません。
          </div>
          <router-link
            :to="{name: 'index'}"
            class="c-btn">
            トップへ
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../../HeaderBar'

export default {
  name: 'CopyrightSplitsCancel',
  components: {
    HeaderBar,
  },
}
</script>

<style scoped>
.cancelled-content {
  margin: auto;
  text-align: center;
}
.title {
  font-size: 20px;
}
.subtitle {
  margin-top: 15px;
  margin-bottom: 42px;
}
</style>
